// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscribersCounterButton_container_3oBlx","badge":"SubscribersCounterButton_badge_1mVMb"};